import React, { Component } from "react";
import { createTimeStr } from "utils/common";
import videoAdjust from "images/video-adjust.png";

class App extends Component {

    state = {
        time: "00:00:00"
    }

    render(){
    	const {
    		visible,
    		showProgress,
	    	isStart,
	    	showPosture,
	    	question,
	    	count,
	    	recordSecond,
	    	adjustPosture,
	    	stopRecord,
	    	startRecord,
	    	questionIndex,
	    	questionTotal,
	    	time,
	    	i18n,
				isRecordReady
	    } = this.props;
        // const countTimeProgress = Number(question.answerTime) * 60;
        const countTimeProgress = Number(question.answerSeconds);
        const videoProgress = (1 - recordSecond/countTimeProgress) * 100;

        return (
        	<div className="video-camera-content" style={{display: visible?"":"none"}}>
	        	<div className="video-camera-contentPhoto">
	            	<div id="live-pusher"></div>
	                { 
	                	showProgress ? <div className="video-progress-wrap">
		                    <div className="video-progress-before">{i18n.record.recordTextPC}：</div>
		                    <div className="video-progress">
		                        <div className="video-progress-inner" style={{width: videoProgress + "%"}}>
		                            <div className="video-progress-dot"></div>
		                        </div>
		                    </div>
		                    <div className="video-progress-after">{i18n.record.recordTextPC1} {time}</div>
		                </div> : null
	            	}
	            	{	
	            		!isStart ?
	                    (showPosture?<div className="video-tryCameraPhotoWrap">
	                        <img src={videoAdjust} />
	                        <div className={i18n.lang === "en_us"?"video-adjust-text-en":"video-adjust-text-zh"}>
	                        	<p className="video-adjust-text">{i18n.ajustModal.title1}</p>
	                        	<p className="video-adjust-text">{i18n.ajustModal.title2}</p>
	                        </div>
	                    </div>:<div className="video-tryCameraPhotoWrap">
	                        {/* <h3>{i18n.question.questionSubtitle}：{question.answerTime >= 1 ?
	                            (question.answerTime + i18n.question.minute):
	                            ((question.answerTime || 0) * 60 + i18n.question.second) }</h3> */}
							<h3>{i18n.question.questionSubtitle}：{question.answerSeconds + i18n.question.second}</h3>
	                        <p>{i18n.question.questionTitle}</p>
	                        <span>{count}s</span>
	                    </div>) : null
	                }
	        	</div>
                {
                	showPosture ? null : <div className="video-camera-contentTit">
	                    <span>{i18n.question.questionText}({(questionIndex < 0 ? 0 : questionIndex) + 1}/{ questionTotal })</span>
	                    <p>{i18n.lang == "en_us" ? question.enName : question.cnName}</p>
	                </div>
	            }
	            {
	            	showPosture ?
                    isRecordReady && <button className="video-adjust-btn" onClick={adjustPosture}>{i18n.ajustModal.btnText}</button>:
                    (isStart ?<button className="video-tryBtnStop video-tryBtn" onClick={stopRecord}>{i18n.record.endTextPC}</button>:
                    <button className="video-tryBtnBegin video-tryBtn" onClick={startRecord}>{i18n.record.startText}</button>)
                }
        	</div>
        )
    }
}

export default App;